import { get } from "lodash";
import { NOTIFICATIONS } from "./notificationConstants.js";
import { AUTHENTICATION } from "../authentication/authenticationConstants.js";

const TEST_NOTIFICATIONS = [
  {
    "@id": "notification-0",
    "@type": "Message",
    object: {
      "@id": "/workstations/123456",
      "@type": "Workstation",
      name: "My workstation"
    },
    subject: {
      "@id": "/users/123456",
      "@type": "User"
    },
    type: "error", // info | warning | error | success
    code: "failStartNoCapacity",
    title: "Failed to start due to no capacity",
    description: "Some longer description about what happened"
  },
  {
    "@id": "notification-1",
    "@type": "Message",
    object: {
      "@id": "/workstations/7891011",
      "@type": "Workstation",
      name: "My second workstation"
    },
    subject: {
      "@id": "/users/7891011",
      "@type": "User"
    },
    type: "success", // info | warning | error | success
    code: "failStartNoCapacity",
    title: "Failed to do stuff",
    description: "Things are happening that we are unable to correct"
  },
  {
    "@id": "notification-2",
    "@type": "Message",
    object: {
      "@id": "/workstations/12131415",
      "@type": "Workstation",
      name: "My third workstation"
    },
    subject: {
      "@id": "/users/12131415",
      "@type": "User"
    },
    type: "warning", // info | warning | error | success
    code: "failStartNoCapacity",
    title: "Noooooooooooooooooooo",
    description: "Noooooooooooooooooooo"
  },
  {
    "@id": "notification-3",
    "@type": "Message",
    object: {
      "@id": "/workstations/16171819",
      "@type": "Workstation",
      name: "My forth workstation"
    },
    subject: {
      "@id": "/users/16171819",
      "@type": "User"
    },
    type: "error", // info | warning | error | success
    code: "failStartNoCapacity",
    title: "Unable to start/stop resource",
    description: "Unable to start/stop resource"
  },
  {
    "@id": "notification-4",
    "@type": "Message",
    object: {
      "@id": "/workstations/2021222324",
      "@type": "Workstation",
      name: "My forth workstation"
    },
    subject: {
      "@id": "/users/2021222324",
      "@type": "User"
    },
    type: "info", // info | warning | error | success
    code: "failStartNoCapacity",
    title: "INFO INFO INFO",
    description: "Info stuff occurred"
  }
];

export const INITIAL = {
  isError: false,
  isReady: false,
  isFetching: false,
  notifications: [],
  notificationCount: 0
};

export function notificationReducer(state = INITIAL, action = {}) {
  switch (action.type) {
    case NOTIFICATIONS.PUSHER_UPDATE:
    case NOTIFICATIONS.ADD:
      const notificationCount = state.notificationCount + 1;
      const newNotification = {
        id: `notification-${notificationCount}`,
        ...action.data
      };

      return {
        ...state,
        notifications: [newNotification, ...state.notifications],
        notificationCount
      };

    case NOTIFICATIONS.DELETE:
      // console.log("notificationReducer NOTIFICATIONS.DELETE", action);
      const id = get(action, `payload.id`, null);
      const notifications = state.notifications.filter(item => item.id !== id);

      return {
        ...state,
        notifications
      };

    case NOTIFICATIONS.RESET:
      // console.log("notificationReducer NOTIFICATIONS.RESET", action);
      return {
        ...INITIAL
      };

    case AUTHENTICATION.LOGOUT.RECEIVE:
      // console.log("notificationReducer AUTHENTICATION.LOGOUT.RECEIVE", action);
      return INITIAL;

    default:
      return state;
  }
}
